import { type CSSProperties } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import GameAppCard from '@components/main/GameAppCard'
import { type GameApp } from '@app-types/api/auth'

interface SortableFavoriteGameCardProps {
  app: GameApp
  onToggleFavorite: (appId: number) => void
}

function SortableFavoriteGameCard({
  app,
  onToggleFavorite,
}: SortableFavoriteGameCardProps) {
  const {
    attributes,
    isDragging,
    listeners,
    setActivatorNodeRef,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: app.id })
  const style: CSSProperties = {
    transform: transform
      ? `translate3d(${Math.round(transform.x)}px, ${Math.round(
          transform.y,
        )}px, 0) scaleX(${transform.scaleX}) scaleY(${transform.scaleY})`
      : undefined,
    transition,
  }

  return (
    <li
      className={isDragging ? 'z-10 opacity-60' : ''}
      ref={setNodeRef}
      style={style}
    >
      <GameAppCard
        app={app}
        dragHandle={
          <button
            aria-label="Перетащить игру"
            className="absolute top-2 left-2 z-10 grid size-7 cursor-grab place-items-center rounded-md border border-slate-200 bg-white text-sm leading-none text-slate-400 transition hover:border-violet-300 hover:text-violet-600 active:cursor-grabbing dark:border-zinc-700 dark:bg-zinc-950 dark:text-zinc-500 dark:hover:border-violet-700 dark:hover:text-violet-300"
            ref={setActivatorNodeRef}
            title="Перетащить"
            type="button"
            {...attributes}
            {...listeners}
          >
            ↕
          </button>
        }
        isFavorite
        onToggleFavorite={onToggleFavorite}
      />
    </li>
  )
}

export default SortableFavoriteGameCard
